import { PROMO_CODE_TYPES } from "./payment.constants"

export const truncateFloatToSignificantDigit = (value, significantDigits) => {
  const scale = Math.pow(10, Math.max(0, significantDigits))
  return Math.floor(value * scale) / scale
}

export const filterRelevantPromoCodes = (promoCodes, products) => {
  return promoCodes.filter(promoCodeData => {
    const promoCodeType = promoCodeData.type
    if (promoCodeType === PROMO_CODE_TYPES.PRODUCT_OFFER) {
      return true
    } else if (promoCodeType === PROMO_CODE_TYPES.PRODUCT_DISCOUNT) {
      const promoCodeProductId = promoCodeData.metadata?.product_id || null
      const promoCodeProductCategory = promoCodeData.metadata?.product_category || null
      return products.find(productData => {
        return (
          promoCodeProductId !== null && productData?.id === promoCodeProductId
        ) || (
          promoCodeProductId === null && (promoCodeProductCategory === null || productData?.category === promoCodeProductCategory)
        )
      })
    } else {
      return false
    }
  })
}

export const calculatePromoCodeSavingsForProduct = (product, promoCodes, preAdjustedPrice) => {
  const basePrice = preAdjustedPrice || product?.list_price || product?.billing_details?.regular?.price?.amount || null
  if (basePrice === null) {
    return 0
  }

  let price = basePrice

  promoCodes
    .map(promoCodeData => {
      const discountType = promoCodeData?.metadata?.discount_type || null
      const discountAmount = promoCodeData?.metadata?.discount_amount || null
      return (discountType !== null && discountAmount !== null)
        ? {
          type: discountType,
          amount: discountAmount,
        }
        : null
    })
    .filter(x => x)
    .sort((a, b) => {
      const aDiscountType = a.type
      const bDiscountType = b.type
      const aVal = aDiscountType === "flat" ? 1 : 0
      const bVal = bDiscountType === "flat" ? 1 : 0
      if (aVal > bVal) {
        return -1
      } else if (bVal > aVal) {
        return 1
      } else {
        return 0
      }
    })
    .forEach(discountData => {
      const discountType = discountData.type
      const discountAmount = discountData.amount
      switch (discountType) {
        case "flat":
          price -= discountAmount
          break
        case "percentage":
          price *= (100 - Math.min(100, discountAmount)) / 100
          break
      }
    })

  return Math.max(0, basePrice - price)
}



// WEBPACK FOOTER //
// ./src/store/payment/payment.utils.js